import { timeline, timelineStates } from '@/mocks/home';
import { cdn } from '@/config/cdn';

/** Mobile / tablet (< lg) sequential fallback: all 5 nodes, no motion. */
export default function TimelineList() {
  return (
    <ol className="lg:hidden lg:motion-reduce:block mt-14 border-l border-[rgba(23,21,21,0.2)] ml-2">
      {timeline.map((t, i) => {
        const img = timelineStates[t.frame];
        return (
          <li key={t.time} className="relative pl-6 pb-10 last:pb-0">
            <span className="absolute -left-[7px] top-2 w-[13px] h-[13px] rounded-full border border-[#171515] bg-[#171515]"></span>
            <div className="flex items-start gap-4">
              <div className="min-w-0 flex-1">
                <p className="fold-label text-[#8A8580]">Node 0{i + 1}</p>
                <p className="mt-1 fold-serif text-3xl tabular-nums text-[#171515]">{t.time}</p>
                <p className="mt-2 text-sm leading-snug text-[#5d5853]">{t.label}</p>
                <p className="mt-2 fold-label text-[#171515]">{t.state}</p>
              </div>
              <div className="w-[120px] h-[90px] sm:w-[160px] sm:h-[120px] shrink-0">
                <img src={cdn(img.src)} alt={img.alt} title={`FOLD. donut · ${t.state}`} className="w-full h-full object-contain" />
              </div>
            </div>
          </li>
        );
      })}
    </ol>
  );
}